export default __webpack_public_path__ + "static/media/IBimageSwinglegretraction1.27988419.png";